import { useRouter } from 'next/router'

import { Text } from '@wartek-id/text-v1'
import { Shimmer } from '@wartek-id/shimmer'
import { Button } from '@wartek-id/button-v1'
import { Icon } from '@wartek-id/icon-v2'

import { Header } from 'app/KinerjaShared/components/Header'
import TablePerencanaanPS from 'app/KinerjaTimPenilaiPSPage/components/TablePerencanaanPS'
import useBasePath from 'app/KinerjaTimPenilaiPSPage/hooks/useBasePath'
import EmptyState from './EmptyState'
import { useAPIGetListPerencanaanPS } from 'api/kinerja/tim-penilai-ps/perencanaan'
import useRoleContext from 'app/KinerjaShared/hooks/useRoleContext'

export default function TimPenilaiDaftarPSSetujuiSekaligusPage() {
  const { basePath } = useBasePath()
  const router = useRouter()
  const { isPPKPengawasSekolah, isProfilePSPegawaiFetched } = useRoleContext()

  const { data, isLoading, isFetched } = useAPIGetListPerencanaanPS({
    filter: 'DAPAT_DISETUJUI_SEKALIGUS',
    opts: {
      enabled: isProfilePSPegawaiFetched && isPPKPengawasSekolah,
    },
  })

  return (
    <div className="px-24 py-6 m-auto max-w-7xl">
      <Header title="Daftar Perencanaan Kinerja" className="mt-6 mb-12" />
      <div className="flex flex-col items-center w-full bg-white border rounded-lg border-subdued">
        {isLoading && (
          <Shimmer height="100px" width="100%" data-testid="loading-list" />
        )}

        {isFetched && data?.data.length === 0 && <EmptyState />}

        {isFetched && data?.data.length > 0 && (
          <>
            <div className="w-full px-8 py-6 space-y-1">
              <div className="flex justify-between py-3 px-4 gap-4 w-full bg-surface-selected-default border border-interactive-default rounded-[4px]">
                <div className="flex flex-col gap-1">
                  <Text variant="heading-md" as="h2" color="informational">
                    {data?.data.length} Perencanaan dapat langsung Anda setujui
                    sekaligus
                  </Text>

                  <Text color="subdued">
                    Perencanaan sudah diperiksa oleh Tim Kinerja.
                  </Text>
                </div>
                <Button
                  size="lg"
                  onClick={() => {
                    router.replace(
                      `${basePath}/penilai/perencanaan/daftar-ps/setujui-sekaligus/konfirmasi`
                    )
                  }}
                >
                  <div className="flex gap-2">
                    <Icon color="inverse">mail_outline</Icon>
                    Setujui ({data?.data.length})
                  </div>
                </Button>
              </div>
            </div>

            <TablePerencanaanPS
              basePath={basePath}
              isBulkApproval
              data={data?.data ?? []}
              isLoading={isLoading}
              className="!mt-0"
            />
          </>
        )}
      </div>
    </div>
  )
}
